/**
 * Labstep
 *
 * @module components/Filter/Tag
 * @desc Tag filter
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { Select as ReactSelect } from 'labstep-web/core/Select';
import type { ReactSelectOption } from 'labstep-web/core/Select/types';
import {
  OrderRequest,
  OrderRequestStatusValues,
} from 'labstep-web/models/order-request.model';
import { ResourceItemStatusValues } from 'labstep-web/models/resource-item.model';
import { PostFilterStatus } from 'labstep-web/services/postFilter/filters/status';
import type React from 'react';
import type { FilterResourceItemStatusProps } from './types';

export const FilterResourceItemStatus: React.FC<
  FilterResourceItemStatusProps
> = ({
  setParams,
  searchParams,
  isOrderRequest,
  addPostFilter,
  actionComponentProps,
}) => {
  const statuses = isOrderRequest
    ? OrderRequestStatusValues
    : ResourceItemStatusValues;

  const placeholder = isOrderRequest
    ? `Select ${OrderRequest.getHumanReadableEntityName()} status`
    : `Select availability status`;

  return (
    <Modal
      header={'Status'}
      content={({ toggleModal }) => (
        <ReactSelect
          defaultValue={
            searchParams.status
              ? {
                  value: searchParams.status,
                  label:
                    statuses[
                      searchParams.status as keyof typeof statuses
                    ],
                }
              : null
          }
          options={Object.keys(statuses).map((key) => ({
            value: key,
            label: statuses[key as keyof typeof statuses],
          }))}
          isClearable
          onChange={(selectedOption: ReactSelectOption) => {
            const value = selectedOption
              ? selectedOption.value
              : undefined;
            if (addPostFilter) {
              addPostFilter(PostFilterStatus.getNode([value]));
            } else if (setParams) {
              setParams({
                status: value,
              });
            }
            toggleModal();
          }}
          placeholder={placeholder}
        />
      )}
      viewComponent={({ toggleModal }) => (
        <ActionComponent
          type="option"
          icon={'info'}
          text={'Status'}
          onClick={toggleModal}
          {...actionComponentProps}
        />
      )}
    />
  );
};
